/**
 * For a table that sits flush against its card, with no CardContent padding of its own: the
 * outermost cells pick up the padding the card would otherwise have given them, so the first
 * column lines up with the card's heading instead of floating two pixels off the edge.
 */
export const EDGE_PADDED_TABLE = '[&_tr>*:first-child]:pl-4 [&_tr>*:last-child]:pr-4'

/**
 * For the table inside a card that fills the screen: the rows scroll, the column headings do not.
 *
 * The background is the card's own — a transparent `thead` would let the rows read straight
 * through it on the way past — and the border is drawn as a shadow, because a `border-b` on a
 * sticky row scrolls away with the cell it belongs to in every engine but one.
 */
export const STICKY_TABLE_HEAD =
  'sticky top-0 z-10 bg-card shadow-[inset_0_-1px_0_0_var(--color-border)] [&_tr]:border-b-0'

/** The card of a list screen: as tall as the space it has, with only the rows inside it scrolling. */
export const FULL_HEIGHT_CARD = 'flex min-h-0 flex-1 flex-col gap-0 py-0'

/** The scroll container of such a card's table. */
export const SCROLLING_TABLE = 'min-h-0 flex-1 overflow-y-auto'

/**
 * A column a phone leaves out. Six columns on a phone are a table that scrolls sideways, with the
 * row's menu off the edge of the screen; what such a column says moves into [PHONE_SUMMARY] in
 * the first column instead.
 */
export const WIDE_ONLY = 'max-md:hidden'

/** The first column's extra line on a phone, carrying what the columns it leaves out would show. */
export const PHONE_SUMMARY =
  'text-muted-foreground mt-0.5 flex flex-wrap items-center gap-x-1.5 text-xs md:hidden'

/** The first column on a phone, which has the row to itself and may wrap rather than run off. */
export const PHONE_WRAPPING_CELL = 'max-md:whitespace-normal'
